
import { IonImg, IonAvatar, IonItem, IonText, IonLabel } from "@ionic/vue";
import { CoinModel } from "@/models/CoinModel";
import { PropType } from "vue";

export default {
  name: "CoinItem",
  components: {
    IonImg,
    IonAvatar,
    IonItem,
    IonText,
    IonLabel,
  },
  props: {
    coin: {
      type: Object as PropType<CoinModel>,
      required: true,
    },
  },
  setup() {
    return {};
  },
};
